import { useTranslation } from "react-i18next";
import i18n, { translate as tr } from "../../i18n";
import React, { useEffect, useRef, useState } from "react";
import SideBar from "../common/sidebar";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import ToggleButton from "../common/togglebutton";
import Calendar from "../common/CalendarPicker";
import moment from "moment-timezone";
import { Modal, Button } from "react-bootstrap";
import Loader from "../common/loader";
import Footer from "../common/footer";
import "../../assets/css/settings.css";
import SettingsSkeleton from "./SettingsSkeleton";

///import { ca } from "date-fns/locale";

export default function Settings() {
  useTranslation();
  const auth    = useSelector((state) => state.auth);
  const isAdmin = auth.is_workspace_admin === 1 || auth.workspace_role === 'ADMIN';
  const [workspaceData, setWorkspaceData] = useState({ title: "", id: "" });
  const [errors, setErrors] = useState({});
  const [profileInfo, setProfileInfo] = useState([]);
  const [is_sole_team_viewer, setTeamViewer] = useState(false);
  const [is_sole_project_creator, setProjectCreator] = useState(false);
  const [is_sole_billable_rate_viewer, setBillablerate] = useState(false);
  const [requiredFields, setRequiredFields] = useState(false);
  const [selected, setSelected] = useState(false);
  const [isLockedTimeEntry, setLockedTimeEntry] = useState(false);
  const [calendarDate, setDate] = useState(new Date());
  const [openCalendar, setOpenCalendar] = useState(false);
  const [maxDate, setMaxDate] = useState(new Date());
  const [dateString, setDateString] = useState("");
  const [isTimeRounding, setTimeRounding] = useState(false);
  const [openRoundingTo, setOpenRoundTo] = useState(false);
  const [openRoundingDuration, setOpenRoundingDuration] = useState(false);
  const [roundingToValue, setRoundingTo] = useState("");
  const [roundingDurationValue, setRoundingDuration] = useState("");
  const [state, setState] = useState({ file: null, fileName: null });
  const [openImg, setOpenImg] = useState(false);
  const [defaultBillable, setDefaultBillable] = useState(false);
  const [defaultBillableRate, setDefaultBillableRate] = useState("");
  const [defaultBillableRateSaving, setDefaultBillableRateSaving] = useState(false);
  const [defaultBillableRateSaved, setDefaultBillableRateSaved] = useState(false);
  const [isUploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [nameSaved, setNameSaved] = useState(false);
  // Overtime settings
  const [otEnabled,       setOtEnabled]       = useState(false);
  const [otDailyHours,    setOtDailyHours]    = useState('8');
  const [otWeeklyHours,   setOtWeeklyHours]   = useState('40');
  const [otRateMultiplier,setOtRateMultiplier]= useState('1.5');
  const [otSaving,        setOtSaving]        = useState(false);
  const [otSaved,         setOtSaved]         = useState(false);
  const [bundesland,      setBundesland]      = useState('');
  const [desktopTrackingEnabled, setDesktopTrackingEnabled] = useState(false);
  const [desktopEnforcement, setDesktopEnforcement] = useState('OPTIONAL');
  const [desktopBgTracking, setDesktopBgTracking] = useState('DISABLED');
  const [desktopBgWeekdaysOnly, setDesktopBgWeekdaysOnly] = useState(true);
  const [desktopBgWorkHoursOnly, setDesktopBgWorkHoursOnly] = useState(true);
  const [desktopBgStart, setDesktopBgStart] = useState('08:00');
  const [desktopBgEnd, setDesktopBgEnd] = useState('19:00');
  const [desktopIdleThresholdMinutes, setDesktopIdleThresholdMinutes] = useState('3');
  const [desktopSaving, setDesktopSaving] = useState(false);
  const [desktopSaved, setDesktopSaved] = useState(false);
  const [aiSendWindowTitles, setAiSendWindowTitles] = useState(false);
  const [aiSaving, setAiSaving] = useState(false);
  const [aiSaved, setAiSaved] = useState(false);
  const [billingGuideOpenStep, setBillingGuideOpenStep] = useState(0);

  // Project activity rules (personal/per-user, like desktop exclusions)
  const [activityRules, setActivityRules] = useState([]);
  const [ruleProjects, setRuleProjects] = useState([]);
  const [ruleError, setRuleError] = useState('');
  const [ruleType, setRuleType] = useState('DOMAIN');
  const [rulePattern, setRulePattern] = useState('');
  const [ruleProjectId, setRuleProjectId] = useState('');
  const [ruleSaving, setRuleSaving] = useState(false);
  const [ruleSuggesting, setRuleSuggesting] = useState(false);
  const [ruleActionId, setRuleActionId] = useState(null);

  // Notifications (personal/per-user)
  const [notifWeeklyReport, setNotifWeeklyReport] = useState(false);
  const [notifDailyReport, setNotifDailyReport] = useState(false);
  const [dailyReportEmail, setDailyReportEmail] = useState('');
  const [dailyReportEmailSaved, setDailyReportEmailSaved] = useState(false);
  const [notifLongRun, setNotifLongRun] = useState(false);
  const [notifLongRunEmail, setNotifLongRunEmail] = useState(false);
  const [notifNewsletter, setNotifNewsletter] = useState(false);
  const [notifGroupSimilar, setNotifGroupSimilar] = useState(false);
  const CURRENCIES = [
    { code: 'AED', name: 'UAE Dirham' },
    { code: 'AUD', name: 'Australian Dollar' },
    { code: 'CAD', name: 'Canadian Dollar' },
    { code: 'CHF', name: 'Swiss Franc' },
    { code: 'EUR', name: 'Euro' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'INR', name: 'Indian Rupee' },
    { code: 'JPY', name: 'Japanese Yen' },
    { code: 'SGD', name: 'Singapore Dollar' },
    { code: 'USD', name: 'US Dollar' },
  ];
  const [defaultCurrency, setDefaultCurrency] = useState('EUR');
  const [openCurrencyDrop, setOpenCurrencyDrop] = useState(false);
  const calendarTriggerRef = useRef(null);
  const calendarPopupRef = useRef(null);
  const roundToRef = useRef(null);
  const roundDurationRef = useRef(null);
  const currencyRef = useRef(null);
  const loadCount = useRef(0);
  const billingWalkthroughSteps = [
    {
      title: "Workspace default",
      sub: "Choose whether new projects start billable or non-billable, and set the fallback rate and currency.",
    },
    {
      title: "Project override",
      sub: "Projects can keep the workspace default or use their own billable flag, hourly rate, and currency.",
    },
    {
      title: "Client billing profile",
      sub: "Client contact details, invoice currency, and payment terms shape the invoice output.",
    },
  ];

  const roundTo = ["Round up to", "Round to nearest", "Round down to"];
  const roundingDuration = [
    "1 minute",
    "5 minutes",
    "6 minutes",
    "10 minutes",
    "12 minutes",
    "15 minutes",
    "30 minutes",
    "1 hour",
    "4 hours",
  ];
  useEffect(() => {
    if (auth.user_properties !== null && auth.user_properties !== undefined) {
      let timeZone = auth.user_properties.timeZone;
      if (timeZone === "" || timeZone === null || timeZone === undefined) {
        moment.tz.setDefault();
      } else {
        timeZone = timeZone.split(" ")[0];
        moment.tz.setDefault(timeZone);
      }
      let today = moment();
      let dd1 = today.date();
      let MM1 = today.month();
      let yy1 = today.year();

      let todayDate = moment({ year: yy1, month: MM1, day: dd1 });
      setMaxDate(todayDate._d);
    } else {
      moment.tz.setDefault();
      let today = moment();
      let dd1 = today.date();
      let MM1 = today.month();
      let yy1 = today.year();
      let todayDate = moment({ year: yy1, month: MM1, day: dd1 });
      setMaxDate(todayDate._d);
    }

    function handleClickOutside(event) {
      if (
        calendarTriggerRef.current && !calendarTriggerRef.current.contains(event.target) &&
        calendarPopupRef.current && !calendarPopupRef.current.contains(event.target)
      ) {
        setOpenCalendar(false);
      }
      if (roundToRef.current && !roundToRef.current.contains(event.target)) {
        setOpenRoundTo(false);
      }
      if (
        roundDurationRef.current &&
        !roundDurationRef.current.contains(event.target)
      ) {
        setOpenRoundingDuration(false);
      }
      if (currencyRef.current && !currencyRef.current.contains(event.target)) {
        setOpenCurrencyDrop(false);
      }
    }

    const doneLoading = () => {
      loadCount.current += 1;
      if (loadCount.current >= 2) setLoading(false);
    };
    getWorkspaceInfo(doneLoading);
    getProfile(doneLoading);
    getNotificationSettings();
    loadActivityRules();
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getWorkspaceInfo = async (done) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let time_duration_format = "Improved";
      let date_format = "DD-MM-YYYY";
      let time_format = "12-hour";
      if (auth.user_properties !== null && auth.user_properties !== undefined) {
        time_duration_format =
          auth.user_properties.timeDurationFormat.split(" ")[0];
        date_format = auth.user_properties.dateFormat;
        time_format = auth.user_properties.timeFormat;
      }
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post(
        "/api/workspace/listbyworkspaceid",
        body,
        config
      );
      if (res.status === 200) {
        res.data.results.map((item) => {
          if (Number(item.id) === Number(workspace_id)) {
            setState({ fileName: item.workspace_logo });
            if (item.is_default_billable === 1) {
              setDefaultBillable(true);
            }
            if (item.default_billable_rate !== undefined && item.default_billable_rate !== null) {
              setDefaultBillableRate(String(item.default_billable_rate));
            } else {
              setDefaultBillableRate("");
            }
            if (item.is_time_rounding === 1) {
              setTimeRounding(true);
              setRoundingTo(item.rounding_to);
              setRoundingDuration(item.rounding_duration);
            }
            if (item.is_time_entry_locked === 1) {
              setLockedTimeEntry(true);
            }
            if (
              item.locked_date !== "" &&
              item.locked_date !== null &&
              item.locked_date !== undefined
            ) {
              let arr = item.locked_date.split("-");
              let dd = arr[0];
              let MM = arr[1];
              let yy = arr[2];
              let m = moment({ year: yy, month: MM, date: dd });
              setDate(m._d);
              setDateString(m.format(date_format));
            } else {
              let yesterday = moment().subtract(1, "days");
              let dd2 = yesterday.date();
              let MM2 = yesterday.month();
              let yy2 = yesterday.year();

              let yesterdayDate = moment({ year: yy2, month: MM2, day: dd2 });
              setDateString(yesterdayDate.format(date_format));
              setDate(yesterdayDate._d);
            }
            if (item.default_currency) {
              setDefaultCurrency(item.default_currency);
            }
            setWorkspaceData({
              title: item.title,
              id: item.id,
            });
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    } finally {
      if (done) done();
    }
  };

  const getProfile = async (done) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/workspace/settings", body, config);
      if (res.status === 200) {
        if (res.data.results[1][0].is_sole_billable_rate_viewer === 1) {
          setBillablerate(true);
        }
        if (res.data.results[1][0].is_sole_project_creator === 1) {
          setProjectCreator(true);
        }
        if (res.data.results[1][0].is_sole_team_viewer === 1) {
          setTeamViewer(true);
        }
        if (res.data.results[1][0].is_required_fields === 1) {
          setRequiredFields(true);
          setSelected(true);
        }
        const ws = res.data.results[1][0];
        if (ws.ot_enabled)          setOtEnabled(true);
        if (ws.ot_daily_hours)      setOtDailyHours(String(ws.ot_daily_hours));
        if (ws.ot_weekly_hours)     setOtWeeklyHours(String(ws.ot_weekly_hours));
        if (ws.ot_rate_multiplier)  setOtRateMultiplier(String(ws.ot_rate_multiplier));
        if (ws.bundesland)          setBundesland(ws.bundesland);
        setDesktopTrackingEnabled(Boolean(ws.desktop_app_tracking_enabled));
        setDesktopEnforcement(ws.desktop_app_enforcement || 'OPTIONAL');
        setDesktopBgTracking(ws.desktop_background_tracking || 'DISABLED');
        setDesktopBgWeekdaysOnly(ws.desktop_bg_weekdays_only !== false);
        setDesktopBgWorkHoursOnly(ws.desktop_bg_work_hours_only !== false);
        setDesktopBgStart(ws.desktop_bg_start || '08:00');
        setDesktopBgEnd(ws.desktop_bg_end || '19:00');
        setDesktopIdleThresholdMinutes(String(Math.round((ws.desktop_idle_threshold_seconds || 180) / 60)));
        setAiSendWindowTitles(Boolean(ws.ai_send_window_titles));
        setProfileInfo(res.data.results[0][0]);
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    } finally {
      if (done) done();
    }
  };

  const getNotificationSettings = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      const body = JSON.stringify({ workspace_id: auth.workspace_id });
      const res = await axios.post('/api/profile/info', body, config);
      if (res.status === 200) {
        const props = res.data.results[1][0];
        if (props) {
          setNotifWeeklyReport(props.send_weekly_report === 1);
          setNotifDailyReport(props.send_daily_report === 1);
          setDailyReportEmail(props.daily_report_email || '');
          setNotifLongRun(props.notification_long_run === 1);
          setNotifLongRunEmail(props.send_long_run_email === 1);
          setNotifNewsletter(props.send_newsletter === 1);
          setNotifGroupSimilar(props.is_group_similar_entries === 1);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const saveDefaultCurrency = async (code) => {
    const prev = defaultCurrency;
    setDefaultCurrency(code);
    setOpenCurrencyDrop(false);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/workspace/update_currency', JSON.stringify({ workspace_id: auth.workspace_id, currency_code: code }), config);
    } catch (err) { setDefaultCurrency(prev); console.log(err); }
  };

  const saveDefaultBillableRate = async () => {
    const next = defaultBillableRate === "" ? "" : String(defaultBillableRate);
    setDefaultBillableRateSaving(true);
    setDefaultBillableRateSaved(false);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/team/workspace-defaults', JSON.stringify({
        workspace_id: auth.workspace_id,
        default_billable_rate: next,
      }), config);
      setDefaultBillableRateSaved(true);
      setTimeout(() => setDefaultBillableRateSaved(false), 1800);
    } catch (err) {
      console.log(err);
    } finally {
      setDefaultBillableRateSaving(false);
    }
  };

  const toggleWeeklyReport = async () => {
    const next = !notifWeeklyReport;
    setNotifWeeklyReport(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/update_weekly_report', JSON.stringify({ weekly_report: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotifWeeklyReport(!next); console.log(err); }
  };

  const toggleDailyReport = async () => {
    const next = !notifDailyReport;
    setNotifDailyReport(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/update_daily_report', JSON.stringify({ daily_report: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotifDailyReport(!next); console.log(err); }
  };

  const saveDailyReportEmail = async () => {
    const email = dailyReportEmail.trim();
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/update_daily_report_email', JSON.stringify({ daily_report_email: email, workspace_id: auth.workspace_id }), config);
      setDailyReportEmail(email);
      setDailyReportEmailSaved(true);
      setTimeout(() => setDailyReportEmailSaved(false), 1800);
    } catch (err) { console.log(err); }
  };

  const toggleLongRun = async () => {
    const next = !notifLongRun;
    setNotifLongRun(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/update_long_notification', JSON.stringify({ long_run_notification: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotifLongRun(!next); console.log(err); }
  };

  const toggleLongRunEmail = async () => {
    const next = !notifLongRunEmail;
    setNotifLongRunEmail(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/update_long_run_email', JSON.stringify({ long_run_email: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotifLongRunEmail(!next); console.log(err); }
  };

  const toggleNewsletter = async () => {
    const next = !notifNewsletter;
    setNotifNewsletter(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/update_send_newsletter', JSON.stringify({ news_letter: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotifNewsletter(!next); console.log(err); }
  };

  const toggleGroupSimilar = async () => {
    const next = !notifGroupSimilar;
    setNotifGroupSimilar(next);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/profile/group_similar', JSON.stringify({ group_similar: next ? 1 : 0, workspace_id: auth.workspace_id }), config);
    } catch (err) { setNotifGroupSimilar(!next); console.log(err); }
  };

  const userCode = () => {
    let firstLetter = "";
    let lastLeter = "";
    if (profileInfo.first_name !== null && profileInfo.last_name != null) {
      firstLetter = profileInfo.first_name.charAt(0);
      lastLeter = profileInfo.last_name.charAt(0);
    } else if (
      profileInfo.email !== null &&
      typeof profileInfo.email !== "undefined"
    ) {
      firstLetter = profileInfo.email.charAt(0);
      lastLeter = profileInfo.email.charAt(1);
    }
    return firstLetter.concat(lastLeter).toUpperCase();
  };

  const handleWorkspaceChange = (e) => {
    setWorkspaceData((prev) => ({ ...prev, title: e.target.value }));
  };

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;
    let title = workspaceData.title;
    if (title === "") {
      formIsValid = false;
      errors["title"] = tr("Please enter the Workspace Title");
    }
    setErrors(errors);
    return formIsValid;
  };

  const editWorkspace = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
    };
    let title = workspaceData.title;
    let workspace_id = workspaceData.id || auth.workspace_id;
    const body = JSON.stringify({ workspace_id, title });

    try {
      if (validateForm() && isAdmin) {
        let res = await axios.put("/api/workspace/edit", body, config);
        if (res.status === 200) {
          setNameSaved(true);
          setTimeout(() => setNameSaved(false), 2000);
        }
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeTeamViewer = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let id = 1;
      let value;
      if (is_sole_team_viewer === true) {
        value = 0;
      } else {
        value = 1;
      }
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ id, value, workspace_id });
      let res = await axios.put("/api/workspace/update_settings", body, config);
      if (res.status === 200) {
        setTeamViewer(!is_sole_team_viewer);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeProjectCreator = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let id = 2;
      let value;
      if (is_sole_project_creator === true) {
        value = 0;
      } else {
        value = 1;
      }
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ id, value, workspace_id });
      let res = await axios.put("/api/workspace/update_settings", body, config);
      if (res.status === 200) {
        setProjectCreator(!is_sole_project_creator);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeBillablerateView = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let id = 3;
      let value;
      if (is_sole_billable_rate_viewer === true) {
        value = 0;
      } else {
        value = 1;
      }
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ id, value, workspace_id });
      let res = await axios.put("/api/workspace/update_settings", body, config);
      if (res.status === 200) {
        setBillablerate(!is_sole_billable_rate_viewer);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const updateRequiredField = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-type": "application/json",
        },
      };
      let id = 4;
      let value;
      if (requiredFields) {
        value = 0;
      } else {
        value = 1;
      }
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({
        workspace_id,
        value,
        id,
      });
      let res = await axios.put("/api/workspace/update_settings", body, config);
      if (res.status === 200) {
        setRequiredFields(!requiredFields);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeDate = async (date) => {
    try {
      let time_duration_format = "Improved";
      let date_format = "DD-MM-YYYY";
      let time_format = "12-hour";
      if (auth.user_properties !== null && auth.user_properties !== undefined) {
        time_duration_format =
          auth.user_properties.timeDurationFormat.split(" ")[0];
        date_format = auth.user_properties.dateFormat;
        time_format = auth.user_properties.timeFormat;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-type": "application/json",
        },
      };
      setDate(date);
      let dd = date.getDate();
      let MM = date.getMonth();
      let yy = date.getFullYear();
      let m = moment({ year: yy, month: MM, date: dd });
      let dString = m.format("DD-MM-YYYY");
      let dd1 = m.date();
      let MM1 = m.month();
      let yy1 = m.year();
      let dbDate = `${dd1}-${MM1}-${yy1}`;
      setDateString(m.format(date_format));
      let value = 1;
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({
        workspace_id,
        value,
        date: dbDate,
      });
      let res = await axios.put(
        "/api/workspace/update_locked_settings",
        body,
        config
      );
      if (res.status === 200) {
        setOpenCalendar(false);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeLockedTimeEntry = async () => {
    try {
      let time_duration_format = "Improved";
      let date_format = "DD-MM-YYYY";
      let time_format = "12-hour";
      if (auth.user_properties !== null && auth.user_properties !== undefined) {
        time_duration_format =
          auth.user_properties.timeDurationFormat.split(" ")[0];
        date_format = auth.user_properties.dateFormat;
        time_format = auth.user_properties.timeFormat;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-type": "application/json",
        },
      };
      let value;
      if (isLockedTimeEntry === true) {
        value = 0;
        let yesterday = moment().subtract(1, "days");
        let dd2 = yesterday.date();
        let MM2 = yesterday.month();
        let yy2 = yesterday.year();

        let yesterdayDate = moment({ year: yy2, month: MM2, day: dd2 });
        setDateString(yesterdayDate.format(date_format));
        setDate(yesterdayDate._d);
      } else {
        value = 1;
      }
      let dd = calendarDate.getDate();
      let MM = calendarDate.getMonth();
      let yy = calendarDate.getFullYear();
      let date = `${dd}-${MM}-${yy}`;
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({
        workspace_id,
        value,
        date,
      });
      let res = await axios.put(
        "/api/workspace/update_locked_settings",
        body,
        config
      );
      if (res.status === 200) {
        setLockedTimeEntry(!isLockedTimeEntry);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeTimeRounding = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-type": "application/json",
        },
      };
      let value, round_to, rounding_duration;
      if (isTimeRounding === true) {
        value = 0;
        round_to = "";
        rounding_duration = "";
      } else {
        value = 1;
        round_to = roundTo[0];
        rounding_duration = roundingDuration[0];
      }
      const body = JSON.stringify({
        workspace_id: auth.workspace_id,
        value,
        round_to,
        rounding_duration,
      });
      let res = await axios.put(
        "/api/workspace/update_rounding_settings",
        body,
        config
      );
      if (res.status === 200) {
        setRoundingTo(round_to);
        setRoundingDuration(rounding_duration);
        setTimeRounding(!isTimeRounding);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeRoundTo = async (item) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-type": "application/json",
        },
      };
      let value = 1,
        round_to,
        rounding_duration;
      round_to = item;
      rounding_duration = roundingDurationValue;
      const body = JSON.stringify({
        workspace_id: auth.workspace_id,
        value,
        round_to,
        rounding_duration,
      });
      let res = await axios.put(
        "/api/workspace/update_rounding_settings",
        body,
        config
      );
      if (res.status === 200) {
        setRoundingTo(round_to);
        setRoundingDuration(rounding_duration);
        setOpenRoundTo(false);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const changeRoundingDuration = async (item) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-type": "application/json",
        },
      };
      let value = 1,
        round_to,
        rounding_duration;
      round_to = roundingToValue;
      rounding_duration = item;
      const body = JSON.stringify({
        workspace_id: auth.workspace_id,
        value,
        round_to,
        rounding_duration,
      });
      let res = await axios.put(
        "/api/workspace/update_rounding_settings",
        body,
        config
      );
      if (res.status === 200) {
        setRoundingTo(round_to);
        setRoundingDuration(rounding_duration);
        setOpenRoundingDuration(false);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const closeImg = () => {
    setErrors({});
    setOpenImg(false);
    getWorkspaceInfo();
  };

  const onInputChange = (e) => {
    setState({ file: e.target.files[0] });
  };

  const imgClick = () => {
    setOpenImg(true);
  };

  const validateImage = () => {
    let fileSize = 1024 * 1024 * 2;
    let errors = {};
    let isValid = false;
    let isValidType = false;
    let allowedExtension = ["jpeg", "jpg", "png"];
    if (state.file !== null && state.file !== undefined && state.file !== "") {
      isValid = true;
    } else {
      errors["input_file"] = tr("Please select a file.");
      setErrors(errors);
      isValid = false;
      return isValid;
    }
    if (state.file && state.file.type.includes("image")) {
      isValid = true;
    } else {
      errors["input_file"] = tr("File is not an Image.");
      setErrors(errors);
      isValid = false;
      return isValid;
    }
    let fileExtension = state.file.type.split("/")[1];
    for (let x in allowedExtension) {
      if (fileExtension === allowedExtension[x]) {
        isValidType = true;
        break;
      }
    }
    if (isValidType === false) {
      let errors = {};
      errors["input_file"] = tr("File Extendion is not acceptable");
      setErrors(errors);
      isValid = false;
      return isValid;
    }
    if (state.file.size < fileSize) {
      isValid = true;
      return isValid;
    } else {
      let errors = {};
      errors["input_file"] = tr("Image size should be less than 2 mb");
      setErrors(errors);
      isValid = false;
      return isValid;
    }
  };

  const saveOtSettings = async (otEnabledOverride) => {
    setOtSaving(true);
    const enabled = otEnabledOverride !== undefined ? otEnabledOverride : otEnabled;
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      await axios.put('/api/workspace/ot-settings', JSON.stringify({
        workspace_id     : auth.workspace_id,
        ot_enabled       : enabled,
        ot_daily_hours   : otDailyHours,
        ot_weekly_hours  : otWeeklyHours,
        ot_rate_multiplier: otRateMultiplier,
        bundesland       : bundesland || null,
      }), config);
      setOtSaved(true);
      setTimeout(() => setOtSaved(false), 2500);
    } catch (err) {
      console.error(err);
    } finally {
      setOtSaving(false);
    }
  };

  const saveDesktopPolicy = async () => {
    setDesktopSaving(true);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      const res = await axios.put('/api/workspace/desktop-policy', JSON.stringify({
        workspace_id    : auth.workspace_id,
        tracking_enabled: desktopTrackingEnabled,
        enforcement     : desktopEnforcement,
        background_tracking: desktopBgTracking,
        background_schedule: {
          weekdays_only  : desktopBgWeekdaysOnly,
          work_hours_only: desktopBgWorkHoursOnly,
          start          : desktopBgStart,
          end            : desktopBgEnd,
        },
        idle_threshold_seconds: Math.max(30, Math.min(3600, Math.round(Number(desktopIdleThresholdMinutes) * 60) || 180)),
      }), config);

      if (res.status === 200 && res.data.policy) {
        setDesktopTrackingEnabled(Boolean(res.data.policy.tracking_enabled));
        setDesktopEnforcement(res.data.policy.enforcement || 'OPTIONAL');
        setDesktopBgTracking(res.data.policy.background_tracking || 'DISABLED');
        setDesktopIdleThresholdMinutes(String(Math.round((res.data.policy.idle_threshold_seconds || 180) / 60)));
      }

      setDesktopSaved(true);
      setTimeout(() => setDesktopSaved(false), 2500);
    } catch (err) {
      console.error(err);
    } finally {
      setDesktopSaving(false);
    }
  };

  const saveAiSettings = async () => {
    setAiSaving(true);
    try {
      const config = { headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
      const res = await axios.put('/api/workspace/ai-settings', JSON.stringify({
        workspace_id: auth.workspace_id,
        ai_send_window_titles: aiSendWindowTitles,
      }), config);

      if (res.status === 200 && res.data.settings) {
        setAiSendWindowTitles(Boolean(res.data.settings.ai_send_window_titles));
      }

      setAiSaved(true);
      setTimeout(() => setAiSaved(false), 2500);
    } catch (err) {
      console.error(err);
    } finally {
      setAiSaving(false);
    }
  };

  function upsertActivityRule(rule) {
    setActivityRules((current) => [...current.filter((item) => item.id !== rule.id), rule]);
  }

  const authHeaders = () => ({ headers: { Authorization: `Bearer ${auth.token}`, 'Content-Type': 'application/json' } });

  const loadActivityRules = async () => {
    try {
      const [rulesRes, projectsRes] = await Promise.all([
        axios.get(`/api/desktop/activity-rules?workspace_id=${auth.workspace_id}`, authHeaders()),
        axios.post('/api/project/list', JSON.stringify({ workspace_id: auth.workspace_id }), authHeaders()),
      ]);
      setActivityRules(rulesRes.data.rules || []);
      setRuleProjects(projectsRes.data.results || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreateActivityRule = async (e) => {
    e.preventDefault();
    const pattern = rulePattern.trim();
    if (!pattern || !ruleProjectId) return;
    try {
      setRuleSaving(true);
      setRuleError('');
      const res = await axios.post('/api/desktop/activity-rules', JSON.stringify({
        workspace_id: auth.workspace_id,
        rule_type: ruleType,
        match_pattern: pattern,
        project_id: parseInt(ruleProjectId, 10),
      }), authHeaders());
      upsertActivityRule(res.data.rule);
      setRulePattern('');
      setRuleProjectId('');
    } catch (err) {
      setRuleError(err?.response?.data?.errors?.[0]?.msg || tr("Unable to save rule."));
    } finally {
      setRuleSaving(false);
    }
  };

  const handleSuggestActivityRules = async () => {
    try {
      setRuleSuggesting(true);
      setRuleError('');
      const res = await axios.post('/api/desktop/activity-rules/suggest', JSON.stringify({ workspace_id: auth.workspace_id }), authHeaders());
      (res.data.rules || []).forEach(upsertActivityRule);
    } catch (err) {
      setRuleError(err?.response?.data?.errors?.[0]?.msg || tr("Unable to scan activity history."));
    } finally {
      setRuleSuggesting(false);
    }
  };

  const handleApproveRule = async (ruleId) => {
    try {
      setRuleActionId(ruleId);
      const res = await axios.post(`/api/desktop/activity-rules/${ruleId}/approve`, JSON.stringify({ workspace_id: auth.workspace_id }), authHeaders());
      upsertActivityRule(res.data.rule);
    } catch (err) {
      console.error(err);
    } finally {
      setRuleActionId(null);
    }
  };

  const handleRejectRule = async (ruleId) => {
    try {
      setRuleActionId(ruleId);
      await axios.post(`/api/desktop/activity-rules/${ruleId}/reject`, JSON.stringify({ workspace_id: auth.workspace_id }), authHeaders());
      setActivityRules((current) => current.filter((item) => item.id !== ruleId));
    } catch (err) {
      console.error(err);
    } finally {
      setRuleActionId(null);
    }
  };

  const handleDeleteRule = async (ruleId) => {
    try {
      setRuleActionId(ruleId);
      await axios.delete(`/api/desktop/activity-rules/${ruleId}?workspace_id=${auth.workspace_id}`, authHeaders());
      setActivityRules((current) => current.filter((item) => item.id !== ruleId));
    } catch (err) {
      console.error(err);
    } finally {
      setRuleActionId(null);
    }
  };

  const uploadImage = async (e) => {
    try {
      if (validateImage() === true) {
        setUploading(true);
        const formData = new FormData();
        formData.append("image", state.file);
        formData.append("workspace_id", auth.workspace_id);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: `Bearer ${auth.token}`,
          },
        };
        let res = await axios.post(
          "/api/workspace/logo_upload",
          formData,
          config
        );
        //console.log(res.data)
        if (res.status === 200) {
          let ff = res.data.filename;
          setErrors({});
          setState({ fileName: ff });
          setOpenImg(false);
          setUploading(false);
        }
        else {
          let errors = {};
          errors["input_file"] = tr("Image upload failed.");
          setErrors(errors);
          setTimeout(() => {
            setOpenImg(false);
            setUploading(false);
          }, 2000);
        }
      }
    } catch (err) {
      if (err.response) {
        console.log(err.response);
      }
      let errors = {};
      errors["input_file"] = tr("Image upload failed.");
      setErrors(errors);
      setUploading(false);
    }
  };

  const changeDefaultBillable = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let id = 5;
      let value;
      if (defaultBillable === true) {
        value = 0;
      } else {
        value = 1;
      }
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ id, value, workspace_id });
      let res = await axios.put("/api/workspace/update_settings", body, config);
      if (res.status === 200) {
        setDefaultBillable(!defaultBillable);
        getProfile();
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  return (
    <div>
      <SideBar />
      <div className="content-wrap" id="wrapper">
        <div className="main dashboard-bg">
          <div className="settings-page">

            {/* ── Page header ── */}
            <div className="settings-page-header">
              <h1>{tr("Settings")}</h1>
              <a href="/integrations">{tr("Manage integrations")}</a>
              <p>{tr("Manage your workspace preferences and configuration")}</p>
            </div>

            {loading && <SettingsSkeleton />}
            <div style={{ display: loading ? 'none' : undefined }}>

            {/* ── Workspace logo & name ── */}
            <div className="st-card">
              <div className="st-workspace-card">
                <div
                  className="st-logo-upload"
                  onClick={isAdmin ? imgClick : undefined}
                  style={{ cursor: isAdmin ? 'pointer' : 'default' }}
                  role={isAdmin ? 'button' : undefined}
                  aria-label={isAdmin ? tr("Upload workspace logo") : undefined}
                  tabIndex={isAdmin ? 0 : undefined}
                  onKeyDown={isAdmin ? (e) => e.key === 'Enter' && imgClick() : undefined}
                >
                  {state.fileName ? (
                    <>
                      <img
                        src={`${process.env.REACT_APP_CLOUDINARY_URL}/${state.fileName}`}
                        alt={tr("Workspace logo")}
                      />
                      {isAdmin && (
                        <div className="st-logo-overlay">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                            <circle cx="12" cy="13" r="4"/>
                          </svg>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="3"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                        <polyline points="21 15 16 10 5 21"/>
                      </svg>
                      <span>{tr("Upload logo")}</span>
                    </>
                  )}
                </div>

                <div className="st-workspace-info">
                  <label htmlFor="workspace-name-input">{tr("Workspace name")}</label>
                  <input
                    id="workspace-name-input"
                    type="text"
                    className="st-workspace-input"
                    readOnly={!isAdmin}
                    onChange={handleWorkspaceChange}
                    onBlur={editWorkspace}
                    value={workspaceData.title}
                    placeholder={tr("Your workspace name")}
                  />
                  {errors.title && <div className="st-input-error">{errors.title}</div>}
                  {nameSaved && <div className="st-input-success">{tr("Workspace name saved")}</div>}
                </div>
              </div>
            </div>

            {/* ── Section label: workspace settings ── */}
            {isAdmin && <div className="st-section-label">{tr("Workspace Settings")}</div>}

            {isAdmin && (
              <div className="st-card st-guide-card">
                <div className="st-guide-card__header">
                  <div>
                    <div className="st-guide-card__badge">{tr("Guided walkthrough")}</div>
                    <h3>{tr("Billing hierarchy")}</h3>
                    <p>{tr("Click a step to expand it. Workspace defaults set the baseline, projects can override them, and client details finish the invoice.")}</p>
                  </div>
                </div>
                <div className="st-guide-steps">
                  {billingWalkthroughSteps.map((step, index) => (
                    <div
                      className={`st-guide-step${billingGuideOpenStep === index ? ' st-guide-step--active' : ''}`}
                      key={tr(step.title)}
                    >
                      <button
                        type="button"
                        className="st-guide-step__trigger"
                        onClick={() => setBillingGuideOpenStep(billingGuideOpenStep === index ? -1 : index)}
                        aria-expanded={billingGuideOpenStep === index}
                        aria-controls={`billing-guide-step-${index}`}
                      >
                        <div className="st-guide-step__index">{String(index + 1).padStart(2, "0")}</div>
                        <div className="st-guide-step__body">
                          <div className="st-guide-step__title">{tr(step.title)}</div>
                          <div className="st-guide-step__sub">{billingGuideOpenStep === index ? tr(step.sub) : tr("Click to expand")}</div>
                        </div>
                        <span className={`st-guide-step__chevron${billingGuideOpenStep === index ? ' st-guide-step__chevron--open' : ''}`} aria-hidden="true">
                          ▾
                        </span>
                      </button>
                      <div
                        id={`billing-guide-step-${index}`}
                        className={`st-guide-step__panel${billingGuideOpenStep === index ? ' st-guide-step__panel--open' : ''}`}
                      >
                        <div className="st-guide-step__panel-text">
                          {tr(step.sub)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="st-guide-note">{tr("Default billing lives here, but project-specific rates and client billing profiles can still override the final invoice flow.")} </div>
              </div>
            )}

            {/* ── Team member rights (admin only) ── */}
            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Team member rights")}</h3>
                    <p>{tr("Access and visibility rights for team members")}</p>
                  </div>
                  <div className="st-card-right">

                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Who can see team activity")}</div>
                      <div className="st-radio-pills" role="radiogroup">
                        <label className={`st-radio-pill${is_sole_team_viewer ? ' active' : ''}`}
                          role="radio" aria-checked={is_sole_team_viewer}
                          tabIndex={is_sole_team_viewer ? 0 : -1}
                          onClick={() => !is_sole_team_viewer && changeTeamViewer()}
                          onKeyDown={(e) => e.key === ' ' && !is_sole_team_viewer && changeTeamViewer()}>
                          <span className="st-radio-dot" />{tr("Admin only")} </label>
                        <label className={`st-radio-pill${!is_sole_team_viewer ? ' active' : ''}`}
                          role="radio" aria-checked={!is_sole_team_viewer}
                          tabIndex={!is_sole_team_viewer ? 0 : -1}
                          onClick={() => is_sole_team_viewer && changeTeamViewer()}
                          onKeyDown={(e) => e.key === ' ' && is_sole_team_viewer && changeTeamViewer()}>
                          <span className="st-radio-dot" />{tr("Everyone")} </label>
                      </div>
                    </div>

                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Who can create projects")}</div>
                      <div className="st-radio-pills" role="radiogroup">
                        <label className={`st-radio-pill${is_sole_project_creator ? ' active' : ''}`}
                          role="radio" aria-checked={is_sole_project_creator}
                          tabIndex={is_sole_project_creator ? 0 : -1}
                          onClick={() => !is_sole_project_creator && changeProjectCreator()}
                          onKeyDown={(e) => e.key === ' ' && !is_sole_project_creator && changeProjectCreator()}>
                          <span className="st-radio-dot" />{tr("Admin only")} </label>
                        <label className={`st-radio-pill${!is_sole_project_creator ? ' active' : ''}`}
                          role="radio" aria-checked={!is_sole_project_creator}
                          tabIndex={!is_sole_project_creator ? 0 : -1}
                          onClick={() => is_sole_project_creator && changeProjectCreator()}
                          onKeyDown={(e) => e.key === ' ' && is_sole_project_creator && changeProjectCreator()}>
                          <span className="st-radio-dot" />{tr("Everyone")} </label>
                      </div>
                    </div>

                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Who can see billable rates")}</div>
                      <div className="st-radio-pills" role="radiogroup">
                        <label className={`st-radio-pill${is_sole_billable_rate_viewer ? ' active' : ''}`}
                          role="radio" aria-checked={is_sole_billable_rate_viewer}
                          tabIndex={is_sole_billable_rate_viewer ? 0 : -1}
                          onClick={() => !is_sole_billable_rate_viewer && changeBillablerateView()}
                          onKeyDown={(e) => e.key === ' ' && !is_sole_billable_rate_viewer && changeBillablerateView()}>
                          <span className="st-radio-dot" />{tr("Admin only")} </label>
                        <label className={`st-radio-pill${!is_sole_billable_rate_viewer ? ' active' : ''}`}
                          role="radio" aria-checked={!is_sole_billable_rate_viewer}
                          tabIndex={!is_sole_billable_rate_viewer ? 0 : -1}
                          onClick={() => is_sole_billable_rate_viewer && changeBillablerateView()}
                          onKeyDown={(e) => e.key === ' ' && is_sole_billable_rate_viewer && changeBillablerateView()}>
                          <span className="st-radio-dot" />{tr("Everyone")} </label>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            )}

            {/* ── Default billing (admin only) ── */}
            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Default billing")}</h3>
                    <p>{tr("New projects will inherit this billable setting by default")}</p>
                  </div>
                  <div className="st-card-right">
                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("New projects")}</div>
                      <div className="st-radio-pills" role="radiogroup">
                        <label className={`st-radio-pill${defaultBillable ? ' active' : ''}`}
                          role="radio" aria-checked={defaultBillable}
                          tabIndex={defaultBillable ? 0 : -1}
                          onClick={() => !defaultBillable && changeDefaultBillable()}
                          onKeyDown={(e) => e.key === ' ' && !defaultBillable && changeDefaultBillable()}>
                          <span className="st-radio-dot" />{tr("Billable")} </label>
                        <label className={`st-radio-pill${!defaultBillable ? ' active' : ''}`}
                          role="radio" aria-checked={!defaultBillable}
                          tabIndex={!defaultBillable ? 0 : -1}
                          onClick={() => defaultBillable && changeDefaultBillable()}
                          onKeyDown={(e) => e.key === ' ' && defaultBillable && changeDefaultBillable()}>
                          <span className="st-radio-dot" />{tr("Non-billable")} </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Desktop app policy")}</h3>
                    <p>{tr("Decide whether metadata-only desktop presence is enabled for this workspace and whether members can skip it.")}</p>
                  </div>
                  <div className="st-card-right">
                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Desktop metadata tracking")}</div>
                      <div className="st-radio-pills" role="radiogroup">
                        <label
                          className={`st-radio-pill${desktopTrackingEnabled ? ' active' : ''}`}
                          role="radio"
                          aria-checked={desktopTrackingEnabled}
                          tabIndex={desktopTrackingEnabled ? 0 : -1}
                          onClick={() => setDesktopTrackingEnabled(true)}
                        >
                          <span className="st-radio-dot" />{tr("Enabled")} </label>
                        <label
                          className={`st-radio-pill${!desktopTrackingEnabled ? ' active' : ''}`}
                          role="radio"
                          aria-checked={!desktopTrackingEnabled}
                          tabIndex={!desktopTrackingEnabled ? 0 : -1}
                          onClick={() => setDesktopTrackingEnabled(false)}
                        >
                          <span className="st-radio-dot" />{tr("Off")} </label>
                      </div>
                    </div>

                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Member requirement")}</div>
                      <div className="st-radio-pills" role="radiogroup">
                        <label
                          className={`st-radio-pill${desktopEnforcement === 'OPTIONAL' ? ' active' : ''}${!desktopTrackingEnabled ? ' disabled' : ''}`}
                          role="radio"
                          aria-checked={desktopEnforcement === 'OPTIONAL'}
                          tabIndex={desktopEnforcement === 'OPTIONAL' ? 0 : -1}
                          onClick={() => desktopTrackingEnabled && setDesktopEnforcement('OPTIONAL')}
                        >
                          <span className="st-radio-dot" />{tr("Members can skip it")} </label>
                        <label
                          className={`st-radio-pill${desktopEnforcement === 'REQUIRED' ? ' active' : ''}${!desktopTrackingEnabled ? ' disabled' : ''}`}
                          role="radio"
                          aria-checked={desktopEnforcement === 'REQUIRED'}
                          tabIndex={desktopEnforcement === 'REQUIRED' ? 0 : -1}
                          onClick={() => desktopTrackingEnabled && setDesktopEnforcement('REQUIRED')}
                        >
                          <span className="st-radio-dot" />{tr("Mandatory for members")} </label>
                      </div>
                    </div>

                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Background tracking without check-in")}</div>
                      <div className="st-radio-pills st-radio-pills--wrap" role="radiogroup">
                        {[
                          ['DISABLED', 'Off (check-in required)'],
                          ['OPTIONAL', 'Members can opt in'],
                          ['REQUIRED', 'Always on'],
                        ].map(([value, label]) => (
                          <label
                            key={value}
                            className={`st-radio-pill${desktopBgTracking === value ? ' active' : ''}${!desktopTrackingEnabled ? ' disabled' : ''}`}
                            role="radio"
                            aria-checked={desktopBgTracking === value}
                            tabIndex={desktopBgTracking === value ? 0 : -1}
                            onClick={() => desktopTrackingEnabled && setDesktopBgTracking(value)}
                          >
                            <span className="st-radio-dot" />
                            {label}
                          </label>
                        ))}
                      </div>
                      <p className="st-field-hint">{tr("Lets the desktop app collect app and website metadata (for time suggestions) without an attendance check-in. Check your data-protection obligations and any works-council agreement before enabling this.")} </p>
                    </div>

                    {desktopTrackingEnabled && (
                      <div className="st-radio-group">
                        <div className="st-radio-label">{tr("Idle threshold")}</div>
                        <div className="st-time-row">
                          <input
                            type="number"
                            min="1"
                            max="60"
                            step="1"
                            value={desktopIdleThresholdMinutes}
                            onChange={(e) => setDesktopIdleThresholdMinutes(e.target.value)}
                            style={{ width: 60 }}
                          />
                          <span>{tr("minutes of no input before a span counts as idle")}</span>
                        </div>
                        <p className="st-field-hint">{tr("Default is 3 minutes. Lower values catch short breaks sooner but may flag brief reading pauses as idle.")}</p>
                      </div>
                    )}

                    {desktopTrackingEnabled && desktopBgTracking !== 'DISABLED' && (
                      <div className="st-radio-group">
                        <div className="st-radio-label">{tr("Tracking schedule")}</div>
                        <label className="st-check-row">
                          <input type="checkbox" checked={desktopBgWeekdaysOnly} onChange={(e) => setDesktopBgWeekdaysOnly(e.target.checked)} />
                          <span>{tr("Weekdays only")}</span>
                        </label>
                        <label className="st-check-row">
                          <input type="checkbox" checked={desktopBgWorkHoursOnly} onChange={(e) => setDesktopBgWorkHoursOnly(e.target.checked)} />
                          <span>{tr("Only during work hours")}</span>
                        </label>
                        {desktopBgWorkHoursOnly && (
                          <div className="st-time-row">
                            <input type="time" value={desktopBgStart} onChange={(e) => e.target.value && setDesktopBgStart(e.target.value)} />
                            <span>{tr("to")}</span>
                            <input type="time" value={desktopBgEnd} onChange={(e) => e.target.value && setDesktopBgEnd(e.target.value)} />
                          </div>
                        )}
                      </div>
                    )}

                      <div className="st-desktop-privacy">
                        <div className="st-desktop-privacy__title">{tr("Privacy guardrails")}</div>
                        <p>{tr("The desktop companion is designed for metadata only: app name, process identifier, active duration, idle state, and timestamps.")}</p>
                        <p>{tr("No screenshots, no keystrokes, no clipboard data, and no document or message contents.")}</p>
                      </div>

                      <div className="st-actions-row">
                        <a
                          className="st-save-btn"
                          href="https://minutezilla.com/download"
                          target="_blank"
                          rel="noreferrer"
                          style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                        >{tr("Download desktop app")} </a>
                        <button className="st-save-btn" onClick={saveDesktopPolicy} disabled={desktopSaving}>
                          {desktopSaving ? tr("Saving...") : desktopSaved ? tr("Saved!") : tr("Save Desktop Policy")}
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            )}

            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("AI suggestion wording")}</h3>
                    <p>{tr("Let the AI suggestion service see a few sanitized window titles to write more specific suggestion titles (e.g. \"Fix login bug\" instead of just \"Work in Google Chrome\").")}</p>
                  </div>
                  <div className="st-card-right">
                    <div className="st-radio-group">
                      <label className="st-check-row">
                        <input type="checkbox" checked={aiSendWindowTitles} onChange={(e) => setAiSendWindowTitles(e.target.checked)} />
                        <span>{tr("Send sanitized window titles to the AI suggestion service")}</span>
                      </label>
                      <p className="st-field-hint">{tr("Off by default. When on, up to 3 window titles per suggestion are sent — with URLs, email addresses, and long numbers stripped first, capped at 80 characters, and never the browser/app name alone. This never changes the suggestion's confidence score or time window, only its wording.")} </p>
                    </div>

                    <div className="st-actions-row">
                      <button className="st-save-btn" onClick={saveAiSettings} disabled={aiSaving}>
                        {aiSaving ? tr("Saving...") : aiSaved ? tr("Saved!") : tr("Save AI Settings")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ── Project rules (personal, like desktop exclusions) ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Project rules")}</h3>
                  <p>{tr("Map an app or website straight to a project on your own desktop activity. A rule always wins over the AI's guess — metadata only, never screen content.")}</p>
                </div>
                <div className="st-card-right">
                  <form onSubmit={handleCreateActivityRule} className="st-radio-group">
                    <div className="st-rate-row">
                      <select className="st-workspace-input" style={{ maxWidth: 140 }} value={ruleType} onChange={(e) => setRuleType(e.target.value)}>
                        <option value="DOMAIN">{tr("Website")}</option>
                        <option value="APP">{tr("App")}</option>
                      </select>
                      <input
                        className="st-workspace-input"
                        value={rulePattern}
                        onChange={(e) => setRulePattern(e.target.value)}
                        placeholder={ruleType === 'DOMAIN' ? 'github.com' : 'Figma'}
                      />
                    </div>
                    <select className="st-workspace-input" value={ruleProjectId} onChange={(e) => setRuleProjectId(e.target.value)}>
                      <option value="">{tr("Select a project…")}</option>
                      {ruleProjects.map((project) => (
                        <option key={project.id} value={project.id}>{project.project_name}</option>
                      ))}
                    </select>
                    <div className="st-actions-row">
                      <button type="submit" className="st-save-btn" disabled={ruleSaving || !rulePattern.trim() || !ruleProjectId}>
                        {ruleSaving ? tr("Saving...") : tr("Add rule")}
                      </button>
                    </div>
                  </form>
                  {ruleError && <p className="st-field-hint" style={{ color: '#c0392b' }}>{ruleError}</p>}

                  {activityRules.some((rule) => rule.status === 'PENDING') && (
                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Suggested from your activity")}</div>
                      <div className="st-rules-list">
                        {activityRules.filter((rule) => rule.status === 'PENDING').map((rule) => (
                          <div key={rule.id} className="st-rule-item st-rule-item--pending">
                            <div>
                              <div>{rule.rule_type === 'DOMAIN' ? tr("Website") : tr("App")}: {rule.match_pattern} → {rule.project?.project_name || `#${rule.project_id}`}</div>
                              <div className="st-field-hint">
                                {rule.confidence_score != null ? `${Math.round(rule.confidence_score * 100)}% of the time` : 'Suggested'}
                              </div>
                            </div>
                            <div className="st-rule-item-actions">
                              <button className="st-rule-btn st-rule-btn--approve" disabled={ruleActionId === rule.id} onClick={() => handleApproveRule(rule.id)}>{tr("Approve")}</button>
                              <button className="st-rule-btn st-rule-btn--reject" disabled={ruleActionId === rule.id} onClick={() => handleRejectRule(rule.id)}>{tr("Dismiss")}</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="st-radio-group">
                    <div className="st-radio-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span>{tr("Active rules")}</span>
                      <button className="st-rule-suggest-btn" disabled={ruleSuggesting} onClick={handleSuggestActivityRules}>
                        {ruleSuggesting ? 'Scanning...' : tr("Suggest from history")}
                      </button>
                    </div>
                    <div className="st-rules-list">
                      {activityRules.filter((rule) => rule.status === 'ACTIVE').length === 0 && (
                        <p className="st-field-hint">{tr("No rules yet.")}</p>
                      )}
                      {activityRules.filter((rule) => rule.status === 'ACTIVE').map((rule) => (
                        <div key={rule.id} className="st-rule-item">
                          <span>{rule.rule_type === 'DOMAIN' ? tr("Website") : tr("App")}: {rule.match_pattern} → {rule.project?.project_name || `#${rule.project_id}`}</span>
                          <button className="st-rule-btn st-rule-btn--reject" disabled={ruleActionId === rule.id} onClick={() => handleDeleteRule(rule.id)}>{tr("Remove")}</button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Rates & Currency (admin only) ── */}
            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Rates & Currency")}</h3>
                    <p>{tr("Set the default rate and currency used for new project billing")}</p>
                  </div>
                  <div className="st-card-right">
                    <div className="st-radio-group">
                      <div className="st-radio-label">{tr("Default billing price")}</div>
                      <div className="st-rate-row">
                        <span className="st-rate-currency">{defaultCurrency || 'CUR'}</span>
                        <input
                          type="number"
                          inputMode="decimal"
                          step="0.01"
                          min="0"
                          className="st-workspace-input st-rate-input"
                          placeholder="75"
                          value={defaultBillableRate}
                          onChange={(e) => setDefaultBillableRate(e.target.value)}
                          onBlur={saveDefaultBillableRate}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              saveDefaultBillableRate();
                            }
                          }}
                        />
                        <span className="st-rate-suffix">{tr("/ hr")}</span>
                      </div>
                      <div className="st-rate-save-state">
                        {defaultBillableRateSaving ? tr("Saving...") : defaultBillableRateSaved ? tr("Saved!") : ' '}
                      </div>
                      <div className="st-rate-hint">
                        <strong>{tr("Projects can still override this rate, but it will be used as the workspace fallback. Current format:")} {defaultCurrency || 'CUR'} {defaultBillableRate || '0'}{tr("/hr")} </strong>
                      </div>
                    </div>

                    <div className="st-radio-label" style={{ marginBottom: '10px' }}>{tr("Default currency")}</div>
                    <div className="st-select-wrap" ref={currencyRef} style={{ minWidth: '240px' }}>
                      <div
                        className={`st-select-trigger${openCurrencyDrop ? ' open' : ''}`}
                        onClick={() => setOpenCurrencyDrop(!openCurrencyDrop)}
                      >
                        <span>
                          {CURRENCIES.find(c => c.code === defaultCurrency)
                            ? `${defaultCurrency} – ${CURRENCIES.find(c => c.code === defaultCurrency).name}`
                            : tr("Select currency")}
                        </span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9"/>
                        </svg>
                      </div>
                      <div className={`st-select-dropdown${openCurrencyDrop ? ' open' : ''}`}>
                        {CURRENCIES.map((c) => (
                          <div
                            key={c.code}
                            className={`st-select-option${defaultCurrency === c.code ? ' selected' : ''}`}
                            onClick={() => saveDefaultCurrency(c.code)}
                          >
                            {c.code} – {c.name}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ── Time entry restrictions (admin only) ── */}
            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Time entry restrictions")}</h3>
                    <p>{tr("Set rules to keep your reports orderly and accurate")}</p>
                  </div>
                  <div className="st-card-right">

                    <div className="st-toggle-row">
                      <div className="st-toggle-wrap">
                        <ToggleButton selected={selected} ariaLabel={tr("Required fields for time entries")} toggleSelected={() => { setSelected(!selected); updateRequiredField(); }} />
                      </div>
                      <div className="st-toggle-info">
                        <h4>{tr("Required fields for time entries")}</h4>
                        <p>{tr("Ensure your team fills in all the information needed for accurate reporting")}</p>
                      </div>
                    </div>

                    <div className="st-toggle-row">
                      <div className="st-toggle-wrap">
                        <ToggleButton selected={isLockedTimeEntry} ariaLabel={tr("Lock time entries")} toggleSelected={changeLockedTimeEntry} />
                      </div>
                      <div className="st-toggle-info">
                        <h4>{tr("Lock time entries")}</h4>
                        <p>{tr("Prevent editing or creating entries before a selected date")}</p>
                        {isLockedTimeEntry && (
                          <div className="st-datepicker-wrap" style={{ marginTop: '12px' }}>
                            <div
                              className="st-lock-date-trigger"
                              onClick={() => setOpenCalendar(!openCalendar)}
                              ref={calendarTriggerRef}
                              role="button"
                              aria-label={tr("Select lock date")}
                              aria-expanded={openCalendar}
                              tabIndex={0}
                              onKeyDown={(e) => e.key === 'Enter' && setOpenCalendar(!openCalendar)}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                <line x1="16" y1="2" x2="16" y2="6"/>
                                <line x1="8" y1="2" x2="8" y2="6"/>
                                <line x1="3" y1="10" x2="21" y2="10"/>
                              </svg>
                              {dateString || tr("Select date")}
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="6 9 12 15 18 9"/>
                              </svg>
                            </div>
                            {openCalendar && (
                              <div className="st-datepicker-popup" ref={calendarPopupRef}>
                                <Calendar
                                  onChange={(item) => changeDate(item)}
                                  weekStartsOn={auth.user_properties?.firstDayOfWeek ?? 0}
                                  date={calendarDate}
                                  maxDate={maxDate}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            )}

            {/* ── Time rounding (admin only) ── */}
            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Time rounding")}</h3>
                    <p>{tr("Round time entries in reports automatically")}</p>
                  </div>
                  <div className="st-card-right">

                    <div className="st-toggle-row">
                      <div className="st-toggle-wrap">
                        <ToggleButton selected={isTimeRounding} ariaLabel={tr("Enable time rounding in reports")} toggleSelected={changeTimeRounding} />
                      </div>
                      <div className="st-toggle-info">
                        <h4>{tr("Time rounding in reports")}</h4>
                        <p>{tr("Reports will apply rounding based on the settings below")}</p>
                      </div>
                    </div>

                    {isTimeRounding && (
                      <div className="st-select-row">
                        {/* Round to */}
                        <div className="st-select-wrap" ref={roundToRef}>
                          <div
                            className={`st-select-trigger${openRoundingTo ? ' open' : ''}`}
                            onClick={() => setOpenRoundTo(!openRoundingTo)}
                          >
                            <span>{roundingToValue || tr("Round direction")}</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="6 9 12 15 18 9"/>
                            </svg>
                          </div>
                          <div className={`st-select-dropdown${openRoundingTo ? ' open' : ''}`}>
                            {roundTo.map((item, i) => (
                              <div
                                key={i}
                                className={`st-select-option${roundingToValue === item ? ' selected' : ''}`}
                                onClick={() => { changeRoundTo(item); setOpenRoundTo(false); }}
                              >
                                {item}
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Rounding duration */}
                        <div className="st-select-wrap" ref={roundDurationRef}>
                          <div
                            className={`st-select-trigger${openRoundingDuration ? ' open' : ''}`}
                            onClick={() => setOpenRoundingDuration(!openRoundingDuration)}
                          >
                            <span>{roundingDurationValue || tr("Duration")}</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="6 9 12 15 18 9"/>
                            </svg>
                          </div>
                          <div className={`st-select-dropdown${openRoundingDuration ? ' open' : ''}`}>
                            {roundingDuration.map((item, i) => (
                              <div
                                key={i}
                                className={`st-select-option${roundingDurationValue === item ? ' selected' : ''}`}
                                onClick={() => { changeRoundingDuration(item); setOpenRoundingDuration(false); }}
                              >
                                {item}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            )}

            {/* ── Section label: personal settings ── */}
            <div className="st-section-label">{tr("Your Account")}</div>

            {/* ── Notifications (personal) ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Notifications")}</h3>
                  <p>{tr("Personal alert and email preferences — applies only to your account")}</p>
                </div>
                <div className="st-card-right">

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notifWeeklyReport} ariaLabel={tr("Weekly email report")} toggleSelected={toggleWeeklyReport} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Weekly email report")}</h4>
                      <p>{tr("Receive a CSV summary of your tracked time every Monday morning")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notifDailyReport} ariaLabel={tr("Daily email report")} toggleSelected={toggleDailyReport} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Daily email report")}</h4>
                      <p>{tr("Receive a summary of yesterday's tracked time every morning at 8:00")}</p>
                    </div>
                  </div>

                  <div className="st-radio-group" style={{ marginTop: -4 }}>
                    <div className="st-radio-label">{tr("Daily report recipient")}</div>
                    <input
                      type="email"
                      className="st-workspace-input"
                      style={{ maxWidth: 340 }}
                      value={dailyReportEmail}
                      onChange={(e) => setDailyReportEmail(e.target.value)}
                      onBlur={saveDailyReportEmail}
                      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); saveDailyReportEmail(); e.currentTarget.blur(); } }}
                      placeholder={tr("Account email (default)")}
                      aria-label={tr("Daily report recipient email")}
                    />
                    <div className="st-rate-hint">{dailyReportEmailSaved ? tr("Saved!") : tr("Leave blank to send the report to your account email.")}</div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notifLongRun} ariaLabel={tr("Long-running timer alert")} toggleSelected={toggleLongRun} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Long-running timer alert")}</h4>
                      <p>{tr("Show an in-app notification when a timer has been running for over 6 hours")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notifLongRunEmail} ariaLabel={tr("Long-running timer email")} toggleSelected={toggleLongRunEmail} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Long-running timer email")}</h4>
                      <p>{tr("Send an email reminder when a timer has been running for over 6 hours")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notifNewsletter} ariaLabel={tr("Product updates and newsletter")} toggleSelected={toggleNewsletter} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Product updates & newsletter")}</h4>
                      <p>{tr("Occasional emails about new features and improvements to Minutezilla")}</p>
                    </div>
                  </div>

                  <div className="st-toggle-row">
                    <div className="st-toggle-wrap">
                      <ToggleButton selected={notifGroupSimilar} ariaLabel={tr("Group similar time entries")} toggleSelected={toggleGroupSimilar} />
                    </div>
                    <div className="st-toggle-info">
                      <h4>{tr("Group similar time entries")}</h4>
                      <p>{tr("Entries with the same title on the same day are collapsed into one row on the timer page")}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* ── Workspace ownership ── */}
            <div className="st-card">
              <div className="st-card-row">
                <div className="st-card-left">
                  <h3>{tr("Workspace ownership")}</h3>
                  <p>{tr("The admin who controls this workspace and its data")}</p>
                </div>
                <div className="st-card-right">
                  <div className="st-owner-row">
                    <div className="st-owner-avatar">
                      {userCode()}
                    </div>
                    <div>
                      <div className="st-owner-name">
                        {profileInfo.first_name} {profileInfo.last_name}
                      </div>
                      <div className="st-owner-role">{tr("Workspace owner")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Overtime Settings ── */}
            {isAdmin && (
              <div className="st-card">
                <div className="st-card-row">
                  <div className="st-card-left">
                    <h3>{tr("Overtime")}</h3>
                    <p>{tr("Set daily and weekly thresholds to automatically flag overtime hours on check-out.")}</p>
                  </div>
                  <div className="st-card-right">
                    <div className="st-ot-toggle-row">
                      <ToggleButton
                        selected={otEnabled}
                        ariaLabel={tr("Enable overtime tracking")}
                        toggleSelected={() => { const v = !otEnabled; setOtEnabled(v); saveOtSettings(v); }}
                      />
                      <span className={`st-ot-status${otEnabled ? ' enabled' : ''}`}>
                        {otEnabled ? tr("Enabled") : tr("Disabled")}
                      </span>
                    </div>

                    {otEnabled && (
                      <div className="st-ot-fields-wrap">
                        <div className="st-ot-fields">
                          <div className="st-ot-field">
                            <label htmlFor="ot-daily">{tr("Daily threshold (hours)")}</label>
                            <input
                              id="ot-daily"
                              type="number" min="1" max="24" step="0.5"
                              className="st-ot-input"
                              value={otDailyHours}
                              onChange={(e) => setOtDailyHours(e.target.value)}
                            />
                          </div>
                          <div className="st-ot-field">
                            <label htmlFor="ot-weekly">{tr("Weekly threshold (hours)")}</label>
                            <input
                              id="ot-weekly"
                              type="number" min="1" max="168" step="0.5"
                              className="st-ot-input"
                              value={otWeeklyHours}
                              onChange={(e) => setOtWeeklyHours(e.target.value)}
                            />
                          </div>
                          <div className="st-ot-field">
                            <label htmlFor="ot-rate">{tr("Rate multiplier")}</label>
                            <input
                              id="ot-rate"
                              type="number" min="1" max="5" step="0.1"
                              className="st-ot-input"
                              value={otRateMultiplier}
                              onChange={(e) => setOtRateMultiplier(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="st-ot-field">
                          <label htmlFor="ot-bundesland">{tr("Bundesland (public holidays)")}</label>
                          <div className="st-select-wrap" style={{ minWidth: 220 }}>
                            <select
                              id="ot-bundesland"
                              className="st-ot-select"
                              value={bundesland}
                              onChange={(e) => setBundesland(e.target.value)}
                            >
                              <option value="">{tr("— National only —")}</option>
                              <option value="BW">Baden-Württemberg (BW)</option>
                              <option value="BY">Bayern (BY)</option>
                              <option value="BE">Berlin (BE)</option>
                              <option value="BB">Brandenburg (BB)</option>
                              <option value="HB">Bremen (HB)</option>
                              <option value="HH">Hamburg (HH)</option>
                              <option value="HE">Hessen (HE)</option>
                              <option value="MV">Mecklenburg-Vorpommern (MV)</option>
                              <option value="NI">Niedersachsen (NI)</option>
                              <option value="NW">Nordrhein-Westfalen (NW)</option>
                              <option value="RP">Rheinland-Pfalz (RP)</option>
                              <option value="SL">Saarland (SL)</option>
                              <option value="SN">Sachsen (SN)</option>
                              <option value="ST">Sachsen-Anhalt (ST)</option>
                              <option value="SH">Schleswig-Holstein (SH)</option>
                              <option value="TH">Thüringen (TH)</option>
                            </select>
                          </div>
                          <p className="st-ot-hint">{tr("Used to exclude state-specific public holidays from leave calculations.")}</p>
                        </div>
                        <p className="st-ot-hint">{tr("e.g. 8h daily · 40h weekly · 1.5× rate means anything beyond 8h/day or 40h/week is counted as overtime.")}</p>
                        <div className="st-ot-actions">
                          <button
                            className={`st-upload-btn${otSaved ? ' st-btn-saved' : ''}`}
                            onClick={saveOtSettings}
                            disabled={otSaving}
                          >
                            {otSaving ? tr("Saving...") : otSaved ? tr("Saved!") : tr("Save Overtime Settings")}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

          </div>{/* end content wrapper */}
          </div>
        </div>

        {/* ── Logo upload modal ── */}
        <Modal show={openImg} onHide={closeImg} dialogClassName="modal-90w">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '16px', fontWeight: 700 }}>{tr("Upload workspace logo")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isUploading && <Loader />}
            <div className="st-upload-area">
              <input
                type="file"
                name="myImage"
                accept="image/*"
                onChange={onInputChange}
              />
            </div>
            {errors.input_file && (
              <div className="st-upload-error">{errors.input_file}</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="st-upload-btn" onClick={uploadImage}>{tr("Upload")} </button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>
    </div>
  );
}
